import React, { useEffect, useState } from 'react'


import { useDispatchCart, useCart  } from '../Components/ContextReducer'
import { useRef } from 'react';

function Card(props){

     const dispatch=useDispatchCart()
    let data= useCart();
    const priceRef=useRef()
    const option=props.options
    let item =props.foodItems
    const priceOption= Object.keys(option);
   
    const[Qty,setQnt]=useState(1)
    const[Size,setSize]=useState(" ")

    

   

 const handleAddToCart = async function (){
    let food =[]
    for(const x of data){
        if(x.id===item._id){
            food=x
            break ;
        }
    }

    if(food !=[]){
        if(food.size===Size){
            await dispatch({type:'UPDATE', id:item._1d, price:finalPrice, qty:Qty})
            return 
        }
        else if(food.size !==Size){
            await dispatch({type: "AddData", id: item._id, name: item.name, qty: Qty, size: Size, price: finalPrice, img: item.img});
            return
        }
        return
    }

    await dispatch({type: "AddData", id: item._id, name: item.name, qty: Qty, size: Size, price: finalPrice, img: item.img});
    await console.log(data)
        
} 

let finalPrice=Qty*parseInt(option[Size]);

useEffect(()=>{
  setSize(priceRef.current.value)

},[])

    return ( 
        

            <div className='car'>
                <div className="card mt-3 bg-info " id='cardd' style={{ "width": "18rem", "maxHeight": "340px" }}> 
                <img id='imgg' src={props.foodItems.img} className="card-img-top" alt="..." style={{height:"130px",objectFit:"fill"}} />
                    <div className="card-body">
                        <h5 className="card-title" >{props.foodItems.name}</h5>
                        
                        <div className="container w-100 rounded">
                            <select className="m-1 h-100  bg-warning rounded" onChange={(e)=>setQnt(e.target.value)}>
                                {Array.from(Array(6), (e, i) => {
                                    return (
                                        <option key={i + 1} value={i + 1}> {i + 1}</option>
                                    )
                                })}
                            </select>

                            <select className="m-2 h-100  bg-danger rounded" ref={priceRef} onChange={(e)=>setSize(e.target.value)}>
                               {
                                priceOption.map((data)=>{
                                   return <option key={data} value={data}>{data}</option>
                                })
                               }
                            </select>

                            <div className=" d-inline fs-5 h-100">₹{finalPrice}</div>
                           
                        </div>
                        <hr/>
                        <button className={'btn btn-success   justify-content-center'} onClick={handleAddToCart}>Add to cart</button>
                    </div>
                </div>
            </div>

        
            )
 }

            export default Card
